import * as apiActions from '@configuratorware/configurator-frontendgui/App/Reducers/Actions';

export const actions = {
  SET_SELECTED_PRODUCTPART: 'SET_SELECTED_PRODUCTPART',
  SET_SUMMARY: 'SET_SUMMARY',
};

export const setSelectedProductPart = (productpart) => ({
  type: actions.SET_SELECTED_PRODUCTPART,
  productpart,
});

export const setSummary = (summary) => ({
  type: actions.SET_SUMMARY,
  summary,
});

export const fetchSummary = () => (dispatch, getState) => {
  const configuration = getState().configurator.configuration;
  return dispatch(apiActions.postData(`/configurations/summary`, configuration, setSummary));
};
